let tooltipTimeout;

export const showTooltip = () => {
  clearTimeout(tooltipTimeout);
  document.getElementById('tooltip').style.display = 'block';
};

export const hideTooltip = () => {
  tooltipTimeout = setTimeout(() => {
    document.getElementById('tooltip').style.display = 'none';
  }, 200);
};

export const boiQuizQuestions = {
  Q1: {
    question: "Is your company incorporated under U.S Laws or laws of a foreign country?",
    options: [
      { key: "A", text: "US Laws" },
      { key: "B", text: "Foreign Laws" }
    ],
    next: {
      A: "Q2",
      B: "Q3"
    }
  },
  Q2: {
    question: "Is the company a corporation or LLC?",
    options: [
      { key: "A", text: "No" },
      { key: "B", text: "Yes" }
    ],
    next: {
      A: "Q4",
      B: "Q5"
    }
  },
  Q3: {
    question: "Have you registered your company to do business in the US by filing a document with a Secretary of State or similar office of the State or tribe?",
    options: [
      { key: "A", text: "Yes" },
      { key: "B", text: "No" }
    ],
    next: {
      A: "Q5",
      B: "FinalResult2"
    }
  },
  Q4: {
    question: "Was the company created by filing of a document with a secretary of state or similar office of the State or tribe?",
    options: [
      { key: "A", text: "No" },
      { key: "B", text: "Yes" }
    ],
    next: {
      A: "FinalResult2",
      B: "Q5"
    }
  },
  Q5: {
    question: <div>Does your company fall under any of the <span style={{ textDecoration: 'underline', cursor: 'help', position: 'relative' }} onMouseOver={showTooltip}>
        <span>23 exempt categories provided by FinCEN?</span>
        <div id="tooltip" style={{ display: 'none', maxHeight: "300px", overflowY: "auto", position: 'absolute', right: 0, backgroundColor: 'white', boxShadow: '0px 0px 5px gray', padding: '10px', zIndex: '9999', fontSize: "14px", color: "000000" }} onMouseOver={showTooltip} onMouseOut={hideTooltip}>
          <ul>
            <li>Securities reporting issuer</li>
            <li>Governmental authority</li>
            <li>Bank</li>
            <li>Credit union</li>
            <li>Depository institution holding company</li>
            <li>Money services business</li>
            <li>Broker or dealer in securities</li>
            <li>Securities exchange or clearing agency</li>
            <li>Other Exchange Act registered entity</li>
            <li>Investment company or investment adviser</li>
            <li>Venture capital fund adviser</li>
            <li>Insurance company</li>
            <li>State-licensed insurance producer</li>
            <li>Commodity Exchange Act registered entity</li>
            <li>Accounting firm</li>
            <li>Public utility</li>
            <li>Financial market utility</li>
            <li>Pooled investment vehicle</li>
            <li>Tax-exempt entity</li>
            <li>Entity assisting a tax-exempt entity</li>
            <li>Large operating company</li>
            <li>Subsidiary of certain exempt entities</li>
            <li>Inactive entity</li>
          </ul>
        </div>
      </span>
      
    </div>,
    options: [
      { key: "A", text: "No" },
      { key: "B", text: "Yes" }
    ],
    next: {
      A: "FinalResult1",
      B: "FinalResult2"
    },
  },
  FinalResult1: {
    result: true
  },
  FinalResult2: {
    result: false
  }
};